import { admin2 } from '@/api/instance'

/**
 * 取得會員設定 admin.memberConfig.singleFind
 * @param {Object} params - 查詢參數
 * @param {string} params.shopId - 商店 ID
 * @returns {import('@/api/instance').Api2Response<Object>} 會員設定資料
 */
export const GetMemberConfig = async ({ shopId }) => {
  return await admin2({
    method: 'GET',
    url: `/${shopId}/memberConfig`,
  })
}

/**
 * 更新會員設定 admin.memberConfig.singleUpdate
 * @param {Object} params - 更新參數
 * @param {string} params.shopId - 商店 ID
 * @param {number} [params.defaultLevel] - 是否啟用新會員自動成為第一級會員
 * @param {number} [params.expireNotificationBefore] - 到期通知提前天數
 * @param {boolean} [params.displayCardLevelName] - 是否顯示會員卡等級名稱
 * @param {boolean} [params.displayCardPhoneNumber] - 是否顯示會員卡手機號碼
 * @param {string} [params.cardStyle] - 會員卡樣式
 * @param {string} [params.CustomCardTemplateId] - 自訂會員卡模板 ID
 * @param {string | null} [params.nullLevelName] - 無等級顯示名稱
 * @param {boolean} [params.memberExternalTransactionAutoRecalculateLevel] - 是否啟用第三方交易異動自動重算等級
 * @param {boolean} [params.memberExternalTransactionVoidAutoRecalculateLevel] - 是否啟用第三方交易作廢自動重算等級
 * @param {boolean} [params.memberExternalTransactionRefundAutoRecalculateLevel] - 是否啟用第三方交易退貨自動重算等級
 * @param {boolean} [params.memberExternalTransactionAutoRevokeGift] - 是否啟用第三方交易異動自動回收等級禮
 * @param {boolean} [params.memberExternalTransactionVoidAutoRevokeGift] - 是否啟用第三方交易作廢自動回收等級禮
 * @param {boolean} [params.memberExternalTransactionRefundAutoRevokeGift] - 是否啟用第三方交易退貨自動回收等級禮
 * @returns {import('@/api/instance').Api2Response<Object>} 更新結果
 */
export const UpdateMemberConfig = async ({
  shopId,
  defaultLevel,
  expireNotificationBefore,
  displayCardLevelName,
  displayCardPhoneNumber,
  cardStyle,
  CustomCardTemplateId,
  nullLevelName,
  memberExternalTransactionAutoRecalculateLevel,
  memberExternalTransactionVoidAutoRecalculateLevel,
  memberExternalTransactionRefundAutoRecalculateLevel,
  memberExternalTransactionAutoRevokeGift,
  memberExternalTransactionVoidAutoRevokeGift,
  memberExternalTransactionRefundAutoRevokeGift,
}) => {
  return await admin2({
    method: 'PUT',
    url: `/${shopId}/memberConfig`,
    data: {
      defaultLevel,
      expireNotificationBefore,
      displayCardLevelName,
      displayCardPhoneNumber,
      cardStyle,
      CustomCardTemplateId,
      nullLevelName,
      memberExternalTransactionAutoRecalculateLevel,
      memberExternalTransactionVoidAutoRecalculateLevel,
      memberExternalTransactionRefundAutoRecalculateLevel,
      memberExternalTransactionAutoRevokeGift,
      memberExternalTransactionVoidAutoRevokeGift,
      memberExternalTransactionRefundAutoRevokeGift,
    },
  })
}

/**
 * 更新會員等級計算排程 admin.memberConfig.levelScheduleUpdate
 * @param {Object} params - 更新參數
 * @param {string} params.shopId - 商店 ID
 * @param {'sameDay' | 'nextDay'} params.levelCalculationScheduleDateOffset - 會員等級排程計算日別
 * @param {string} params.levelCalculationScheduleTime - 會員等級排程計算時間 HH:mm
 * @returns {import('@/api/instance').Api2Response<Object>} 更新結果
 */
export const UpdateMemberLevelSchedule = async ({
  shopId,
  levelCalculationScheduleDateOffset,
  levelCalculationScheduleTime,
}) => {
  return await admin2({
    method: 'PUT',
    url: `/${shopId}/memberConfig/levelSchedule`,
    data: {
      levelCalculationScheduleDateOffset,
      levelCalculationScheduleTime,
    },
  })
}
